import { css } from '@emotion/core';
import { BrowserUtils } from '../../utils';

export const highContrastStylesBase = color => css`
  .vds-icon {
    fill: ${color} !important;
  }
`;
export const highContrastStyles = theme => css`
  @media screen and (-ms-high-contrast: active) {
    ${highContrastStylesBase('white')}
  }

  @media screen and (-ms-high-contrast: black-on-white) {
    ${highContrastStylesBase('black')}
  }

  ${BrowserUtils.isHighContrastMode() ? highContrastStylesBase('black') : ''}
`;

export default () => ({
  iconStyles: ({ cybs }) => css`
    &.vds-icon use {
      fill: ${cybs?.core?.primary ?? '#2b6afd'};
    }
  `
});
